export default defineNuxtRouteMiddleware(async () => {
	const store = useAuthStore()
	const data = await useRequestFetch()('/api/me')
	if (data) {
		store.setUser(data)
	} else {
		store.setUser(null)
	}
})